var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// Font Resizer ------------------- Start
function fontResizer() {
  var perc = parseInt(sw) / 120;
  document.body.style.fontSize = perc + "px";
}

// Loader ------------------- Start
function pageLoader() {
  // document.querySelector("html").classList.add("loadjs");
  setTimeout(function () {
    if (document.querySelector(".loader-first")) {
      document.querySelector(".loader-first").style.display = "none";
      document.querySelector("html").classList.remove("loadjs");
    }
  }, 2300);
}

// Window on Load ----------------- Start
window.onload = function () {
  pageLoader();
  if (sw > 1199) {
    fontResizer();
  }
};

// Window On Resize ----------------- Start
(function () {
  window.addEventListener("resize", (event) => {
    sw = window.innerWidth;
    sh = window.innerHeight;
    if (sw > 1025) {
      if (sw < 1400 && sw > 1300 && sh > 900) {
      } else {
        fontResizer();
      }
    }
  });
})();

// Landscape Mode off ---------------- Start
const mql = window.matchMedia("(orientation:landscape)");
mql.addEventListener("change", (event) => {
  if (event.matches) {
    if (innerWidth < 930) {
      // console.log("Now in landscape orientation");
      document.getElementById("portrait-warning").style.display = "flex";
    }
  } else {
    // console.log("Now in portrait orientation");
    document.getElementById("portrait-warning").style.display = "none";
  }
});

// Sticky Header ---------------- Start
(function () {
  if (document.querySelector(".header")) {
    function stickyHeader() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
    window.addEventListener("scroll", (event) => {
      stickyHeader();
    });
  }
})();

// SVG Convert Code
window.addEventListener("load", function () {
  (function () {
    if (document.querySelector(".svg-convert")) {
      let svgs = document.querySelectorAll("img.svg-convert");
      svgs.forEach((el) => {
        const imgID = el.getAttribute("id");
        const imgClass = el.getAttribute("class");
        const imgURL = el.getAttribute("src");

        fetch(imgURL)
          .then((response) => response.text())
          .then((data) => {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(data, "text/html");
            let svg = xmlDoc.querySelector("svg");
            if (typeof imgID !== "undefined") {
              svg.setAttribute("id", imgID);
            }

            if (typeof imgClass !== "undefined") {
              svg.setAttribute("class", imgClass + " svg-converted");
            }

            svg.removeAttribute("xmlns:a");

            el.parentNode.replaceChild(svg, el);
          });
      });
    }
  })();
});

// animate Observer------------Start
(function () {
  if (window.innerWidth > 767) {
    let anim = [...document.querySelectorAll(".animate")];

    let options = {
      rootMargin: "0px",
      threshold: 0.2,
    };

    let animate = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = `anim 1s ${entry.target.dataset.delay} forwards ease-out`;
        }
      });
    };

    let observer = new IntersectionObserver(animate, options);

    anim.forEach((item, idx) => {
      observer.observe(item);
    });
  }
})();

// Lazy Load Img observer
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const imgElements = document.querySelectorAll("img[data-src]");

    const lazyLoadingImage = (entries, observer2) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.src = entry.target.dataset.src;
        entry.target.addEventListener("load", () => {
          entry.target.classList.remove("lazy-img");
          observer2.unobserve(entry.target);
        });
      });
    };
    const lazyLoadingObserver = new IntersectionObserver(lazyLoadingImage, {
      threshold: 0,
      rootMargin: "0px 0px 150px 0px",
    });
    imgElements.forEach((img) => lazyLoadingObserver.observe(img));
  });
})();

if (document.querySelector(".home-hero__heroSlider")) {
  var heroSlider = new Swiper(".home-hero__heroSlider", {
    slidesPerView: 1,
    allowTouchMove: true,
    loop: true,
    watchSlidesProgress: true,
    speed: 2000,
    allowTouchMove: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: ".home-hero__heroSlider .swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
}

if (document.querySelector(".about-slider")) {
  var aboutSlider = new Swiper(".about-slider", {
    slidesPerView: 1,
    allowTouchMove: true,
    loop: true,
    watchSlidesProgress: true,
    speed: 2000,
    allowTouchMove: true,
    spaceBetween: 20,
    pagination: {
      el: ".about-slider .swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
}

if (document.querySelector(".solution-thumbSlider")) {
  var solutionThumbSlider = new Swiper(".solution-thumbSlider", {
    slidesPerView: "auto",
    allowTouchMove: true,
    watchSlidesProgress: true,
    speed: 2000,
    allowTouchMove: true,
  });
}

if (document.querySelector(".solution-contentSlider")) {
  var solutionContentSlider = new Swiper(".solution-contentSlider", {
    slidesPerView: 1,
    allowTouchMove: true,
    watchSlidesProgress: true,
    speed: 800,
    allowTouchMove: false,
    thumbs: {
      swiper: solutionThumbSlider,
    },
  });
}

if (document.querySelector(".logistics-slider")) {
  var logisticsSlider = new Swiper(".logistics-slider", {
    slidesPerView: "auto",
    allowTouchMove: true,
    watchSlidesProgress: true,
    speed: 2000,
    allowTouchMove: true,
    spaceBetween: 30,
    navigation: {
      nextEl: ".tech-logistics .pagination-arrows .swiper-button-next",
      prevEl: ".tech-logistics .pagination-arrows .swiper-button-prev",
    },
    scrollbar: {
      el: ".tech-logistics .pagination-arrows .swiper-scrollbar",
      draggable: true,
    },
  });
}

if (document.querySelector(".stories-slider")) {
  var storiesSlider = new Swiper(".stories-slider", {
    slidesPerView: 1,
    allowTouchMove: true,
    watchSlidesProgress: true,
    speed: 2000,
    allowTouchMove: true,
    spaceBetween: 10,
    navigation: {
      nextEl:
        ".news-stories .news-wrapper .pagination-arrows .swiper-button-next",
      prevEl:
        ".news-stories .news-wrapper .pagination-arrows .swiper-button-prev",
    },
  });
}

if (document.querySelector(".latest-slider")) {
  var latestSlider = new Swiper(".latest-slider", {
    slidesPerView: 1,
    allowTouchMove: true,
    watchSlidesProgress: true,
    loop: false,
    speed: 2000,
    allowTouchMove: true,
    spaceBetween: 10,
    navigation: {
      nextEl:
        ".news-stories .latest-update .pagination-arrows .swiper-button-next",
      prevEl:
        ".news-stories .latest-update .pagination-arrows .swiper-button-prev",
    },
    scrollbar: {
      el: ".news-stories .latest-update .pagination-arrows .swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      768: {
        spaceBetween: 20,
        slidesPerView: 1,
      },
      991: {
        spaceBetween: 20,
        slidesPerView: 2,
      },
      1200: {
        spaceBetween: 40,
        slidesPerView: 2.66,
      },
    },
  });
}

// Function for loading iframe video on slider to optimize page load
// function addIFrame(slide, index) {
//   slide.forEach(item => {
//     let x = item.children[0]?.getElementsByClassName('iframeVidz');
//     if (x && x.length) {
//       x[0].remove();
//     }
//   });

//   let iframeDataElement = document.querySelector(".iframeData");

//   // Check if the iframeDataElement exists
//   if (iframeDataElement) {
//     let dsrc1 = iframeDataElement.getAttribute("data-src");

//     if (dsrc1) {
//       let iFrame1 =
//         '<iframe class="iframeVidz" src="' +
//         dsrc1 +
//         '" style=""></iframe>';
//       setTimeout(function () {
//         let a = slide[index].querySelector(".iframeData");
//         if (a) {
//           a.innerHTML = iFrame1;
//         }
//       }, 500);
//     }
//   }
// }

(function () {
  if (document.querySelector("#toggle")) {
    let toggleMenu = document.querySelector("#toggle");
    let htmlEl = document.querySelector("html");

    toggleMenu.addEventListener("click", (event) => {
      let _this = event.target;
      _this.classList.toggle("active");
      document.querySelector(".navigation").classList.toggle("active");
      document.querySelector(".navigation").classList.toggle("open");

      // Toggle overflow-hidden class on html element
      htmlEl.classList.toggle("overflow-hidden");
    });
  }
})();

document.querySelectorAll(".toggle-btn").forEach((toggle) => {
  toggle.addEventListener("click", function () {
    // Remove active class and max-height from all other toggles and menus
    document.querySelectorAll(".toggle-btn").forEach((item) => {
      if (item !== this) {
        item.classList.remove("active");
        item.nextElementSibling.style.maxHeight = null;
      }
    });

    // Toggle active class on the clicked toggle
    this.classList.toggle("active");

    // Toggle max-height of the next sibling (inner-menu)
    const footerMenu = this.nextElementSibling;
    if (footerMenu.style.maxHeight) {
      footerMenu.style.maxHeight = null; // Collapse the menu
    } else {
      footerMenu.style.maxHeight = footerMenu.scrollHeight + "px"; // Expand the menu
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".corporate-sustainability.section");

  if (section) {
    setTimeout(() => {
      const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add("inview");
            observerInstance.disconnect();
          }
        });
      });

      observer.observe(section);
    }, 6000);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const listItems = document.querySelectorAll(".direct-presence ul li");
  const mapContainers = document.querySelectorAll(
    ".direct-presenceMap .map-img"
  );

  // Set the default active map image
  const defaultMap = document.querySelector(
    ".direct-presenceMap .map-img:not([data-id])"
  );
  if (defaultMap) {
    defaultMap.classList.add("active");
  }

  // ✅ Function to handle activation on click
  const activateItem = (item) => {
    // Remove active class from all list items and map containers
    listItems.forEach((li) => li.classList.remove("active"));
    mapContainers.forEach((container) => container.classList.remove("active"));

    // Add active class to the clicked item and corresponding map
    item.classList.add("active");
    const id = item.id;
    const matchingMap = document.querySelector(
      `.direct-presenceMap .map-img[data-id="${id}"]`
    );
    if (matchingMap) {
      matchingMap.classList.add("active");
    } else if (defaultMap) {
      defaultMap.classList.add("active");
    }
  };

  // ✅ Function to handle hover effect
  const hoverItem = (item) => {
    const id = item.id;

    // Remove hover-img class from all items and maps
    listItems.forEach((li) => li.classList.remove("hover-img"));
    mapContainers.forEach((container) =>
      container.classList.remove("hover-img")
    );

    // Add hover-img class to the hovered item and corresponding map
    item.classList.add("hover-img");
    const matchingMap = document.querySelector(
      `.direct-presenceMap .map-img[data-id="${id}"]`
    );
    if (matchingMap) {
      matchingMap.classList.add("hover-img");
    }
  };

  // ✅ Apply events for each list item
  listItems.forEach((item) => {
    // Click event for activation
    item.addEventListener("click", () => activateItem(item));

    // Mouseenter event for hover effect
    item.addEventListener("mouseenter", () => hoverItem(item));

    // Mouseleave event to remove hover effect
    item.addEventListener("mouseleave", () => {
      item.classList.remove("hover-img");
      mapContainers.forEach((container) =>
        container.classList.remove("hover-img")
      );

      // Restore the active state if any
      const activeItem = document.querySelector(
        ".direct-presence ul li.active"
      );
      if (activeItem) {
        const activeMap = document.querySelector(
          `.direct-presenceMap .map-img[data-id="${activeItem.id}"]`
        );
        if (activeMap) {
          activeMap.classList.add("active");
        }
      } else if (defaultMap) {
        defaultMap.classList.add("active");
      }
    });
  });

  // ✅ Reset to default on clicking outside
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".direct-presence ul li")) {
      listItems.forEach((li) => li.classList.remove("active", "hover-img"));
      mapContainers.forEach((container) =>
        container.classList.remove("active", "hover-img")
      );
      if (defaultMap) {
        defaultMap.classList.add("active");
      }
    }
  });
});



// document.querySelectorAll(".mobileToggle", "menulink").forEach((toggle) => {
//   toggle.addEventListener("click", function () {
//     // Remove active and opened classes from all other toggles and menus
//     document.querySelectorAll(".mobileToggle").forEach((item) => {
//       if (item !== this) {
//         item.classList.remove("active");
//         item.nextElementSibling.classList.remove("opened");
//         item.nextElementSibling.style.maxHeight = null;
//       }
//     });

//     // Toggle active class on the clicked toggle
//     this.classList.toggle("active");

//     // Toggle max-height and opened class of the next sibling (inner-menu)
//     const innerMenu = this.nextElementSibling;
//     if (innerMenu.style.maxHeight) {
//       innerMenu.style.maxHeight = null; // Collapse the menu
//       innerMenu.classList.remove("opened");
//     } else {
//       innerMenu.style.maxHeight = innerMenu.scrollHeight + "px"; // Expand the menu
//       innerMenu.classList.add("opened");
//     }
//   });

// });



document.querySelectorAll(".menu__menuitem--menulink, .mobileToggle").forEach((toggle) => {
  toggle.addEventListener("click", function (event) {

    const parentLi = this.closest(".menu__menuitem.has-child");
    const mobileToggle = parentLi.querySelector(".mobileToggle");
    const innerMenu = parentLi.querySelector(".mega-menu");

    // Remove active and opened classes from all other toggles and menus
    document.querySelectorAll(".menu__menuitem.has-child").forEach((item) => {
      if (item !== parentLi) {
        item.classList.remove("active");
        item.querySelector(".mega-menu").classList.remove("opened");
        item.querySelector(".mega-menu").style.maxHeight = null;
        item.querySelector(".mobileToggle").classList.remove("active");
      }
    });

    // Toggle active class on the clicked toggle
    mobileToggle.classList.toggle("active");

    // Toggle max-height and opened class of the menu
    if (innerMenu.style.maxHeight) {
      innerMenu.style.maxHeight = null; // Collapse the menu
      innerMenu.classList.remove("opened");
    } else {
      innerMenu.style.maxHeight = innerMenu.scrollHeight + "px"; // Expand the menu
      innerMenu.classList.add("opened");
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(".single-image");
  const beforeColors = document.querySelectorAll(".before-color");
  let currentIndex = 0;
  let autoPlayInterval;
  const autoPlaySpeed = 5000; // Autoplay speed for both sliders

  // Initialize Swiper thumbnail slider
  let solutionThumbSlider;
  if (document.querySelector(".solution-thumbSlider")) {
    solutionThumbSlider = new Swiper(".solution-thumbSlider", {
      slidesPerView: "auto",
      allowTouchMove: true,
      watchSlidesProgress: true,
      speed: autoPlaySpeed,
    });

    // Handle clicks on the thumbnail slider
    solutionThumbSlider.on("click", function () {
      currentIndex = solutionThumbSlider.clickedIndex;
      updateSlider();
      stopAutoPlay(); // Stop autoplay on user interaction
    });
  }

  // Initialize Swiper content slider
  let solutionContentSlider;
  if (document.querySelector(".solution-contentSlider")) {
    solutionContentSlider = new Swiper(".solution-contentSlider", {
      slidesPerView: 1,
      allowTouchMove: true,
      watchSlidesProgress: true,
      speed: autoPlaySpeed,
      allowTouchMove: false,
      thumbs: {
        swiper: solutionThumbSlider,
      },
    });
  }

  // Update slider to manage active slides and transitions
  function updateSlider() {
    slides.forEach((slide, index) => {
      slide.classList.remove("active", "next", "next-next", "scrolled");
      slide.style.position = "absolute";
      slide.style.transition =
        "transform 0.5s ease-in-out, width 0.5s ease-in-out, height 0.5s ease-in-out, left 0.5s ease-in-out";

      if (index === currentIndex) {
        // Active Slide
        slide.classList.add("active");
        slide.style.width = "600px";
        slide.style.height = "541px"; // Set height for active slide
        slide.style.left = "0";
        slide.style.transform = "translateX(0)";
        slide.style.zIndex = 3;
      } else if (index === currentIndex + 1) {
        // Next Slide
        slide.classList.add("next");
        slide.style.width = "270px";
        slide.style.height = "243px"; // Set height for next slide
        slide.style.left = "0";
        slide.style.transform = "translateX(37.5em)";
        slide.style.zIndex = 2;
      } else if (index === currentIndex + 2) {
        // Next-Next Slide
        slide.classList.add("next-next");
        slide.style.width = "80px";
        slide.style.height = "72px"; // Set height for next-next slide
        slide.style.left = "0";
        slide.style.transform = "translateX(54.4em)";
        slide.style.zIndex = 1;
      } else if (index === currentIndex + 3) {
        // Next-Next-Next Slide
        slide.classList.add("next-next-next");
        slide.style.width = "80px";
        slide.style.height = "72px"; // Set height for next-next-next slide
        slide.style.left = "0";
        slide.style.transform = "translateX(71.3em)";
        slide.style.zIndex = 0;
      } else {
        // Other slides
        slide.classList.add("scrolled");
        slide.style.width = "600px";
        slide.style.height = "541px"; // Default height
        slide.style.left = "0";
        slide.style.transform = "translateX(0)";
        slide.style.zIndex = 0;
      }
    });

    // Update the background-before logic
    updateBackground();
  }


  // Update background colors for the `.before-color` elements
  function updateBackground() {
    beforeColors.forEach((color, index) => {
      color.classList.remove(
        "active",
        "next",
        "next-next",
        "next-next-next",
        "scrolled"
      );

      if (index === currentIndex) {
        color.classList.add("active");
      } else if (index === currentIndex + 1) {
        color.classList.add("next");
      } else if (index === currentIndex + 2) {
        color.classList.add("next-next");
      } else if (index === currentIndex + 3) {
        color.classList.add("next-next-next");
      } else {
        color.classList.add("scrolled");
      }
    });
  }

  // Function to start autoplay if screen width is less than 480px
  function startAutoPlay() {
    if (window.innerWidth < 480) {
      stopAutoPlay(); // Ensure no duplicate intervals
      autoPlayInterval = setInterval(() => {
        currentIndex = (currentIndex + 1) % slides.length; // Move to next slide
        updateSlider();
        if (solutionThumbSlider) solutionThumbSlider.slideNext();
        if (solutionContentSlider) solutionContentSlider.slideNext();
      }, autoPlaySpeed);
    } else {
      stopAutoPlay();
    }
  }

  // Function to stop autoplay
  function stopAutoPlay() {
    if (autoPlayInterval) {
      clearInterval(autoPlayInterval);
      autoPlayInterval = null;
    }
  }

  // Start autoplay and listen for resize events
  startAutoPlay();
  window.addEventListener("resize", startAutoPlay);
  window.addEventListener("load", startAutoPlay);

  // Initialize the slider
  updateSlider();
});

document.addEventListener("DOMContentLoaded", function () {
  const searchWrapper = document.querySelector(".search-wrapper");
  const searchPopup = document.querySelector(".search-popup");
  const crossIcon = document.querySelector(".cross-icon");

  // Check if elements exist before proceeding
  if (searchWrapper && searchPopup && crossIcon) {
    // Open search popup on search-wrapper click
    searchWrapper.addEventListener("click", function () {
      searchPopup.classList.add("open");
    });

    // Close search popup on cross-icon click
    crossIcon.addEventListener("click", function () {
      searchPopup.classList.remove("open");
    });

    // Optional: Close on ESC key press
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        searchPopup.classList.remove("open");
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const logo = document.querySelector(".loader-first");
  logo.classList.add("show");
});
